import axios from 'axios';
import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost, postFile, postMigrationFile } from './axiosUtils';
import './axiosInterceptor';

const AttachmentService = {
  async downloadProfileImage(userId: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost('/attachment/downloadProfile', { loginId: userId });
  },
  async downloadBeforeAfter(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost('/attachment/downloadFile', payload);
  },
  async downloadOther(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axios.post('/attachment/downloadOtherFile', payload, {
      responseType: 'blob',
    });
  },

  async downloadSelected(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axios.post('/attachment/downloadSelectedFile', payload, {
      responseType: 'blob',
    });
  },

  async postUploadBeforeAfter(formData: FormData): AxiosUtilsType {
    return await postFile(`attachment/uploadFile`, formData);
  },
  async postUploadProfile(formData: FormData): AxiosUtilsType {
    return await postFile(`attachment/uploadProfile`, formData);
  },
  async removeProfile(loginId: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`attachment/removeProfile`, loginId);
  },
  // Request presigned S3 PUT URLs for check-in proof files (JSON only, WAF-safe).
  async getCheckInUploadUrls(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost('/attachment/checkInUploadUrls', payload);
  },
  // Upload a file straight to S3 via the presigned PUT URL (bypasses the BFF/WAF).
  // Uses a FRESH axios instance (not the shared one) so the global request
  // interceptor's baseURL + app-token headers are NOT applied — S3 must receive the
  // absolute presigned URL with only the signed headers.
  async putToPresignedUrl(uploadUrl: string, file: File): Promise<boolean> {
    const bareClient = axios.create();
    const res = await bareClient.put(uploadUrl, file, {
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
      transformRequest: [d => d],
    });
    return res.status >= 200 && res.status < 300;
  },
  async uploadBulkUpdateFile(name: string, formData: FormData, campaignId: string): AxiosUtilsType {
    return await postMigrationFile(`bulk-upload/inventory?name=${name}&campaignId=${campaignId}`, formData);
  },
};
export default AttachmentService;
